import axios from "axios";
import Incident from "@/features/Incidents/Incident";

export interface IncidentResponse {
    incidents: Incident[];
    totalIncidents: number;
}

export class IncidentService {
    private incidentURL = "/api/v1/incidents";

    async getIncidentFromServer(id: string): Promise<Incident> {
        const response = await axios.get(this.incidentURL + "/" + id);
        return response.data as Incident;
    }

    async getIncidentsFromServer(query: object | null = null): Promise<IncidentResponse> {
        const response = await axios.get(this.incidentURL, { params: query });

        return response.data as IncidentResponse;
    }

    async createIncident(supplierID: string): Promise<string> {
        const response = await axios.postForm(this.incidentURL, {
            supplierID: supplierID,
            currentDate: new Intl.DateTimeFormat("en-US").format(new Date()),
        });

        return response.data;
    }

    async updateIncident(incident: Incident): Promise<string> {
        const response = await axios.put(this.incidentURL + "/" + incident.id, incident);

        return response.data;
    }

    async deleteIncident(id: string): Promise<void> {
        await axios.delete(this.incidentURL + "/" + id);
    }
}
